import { render, staticRenderFns } from "./AccionAlerta.vue?vue&type=template&id=058f3267"
import script from "./AccionAlerta.vue?vue&type=script&lang=js"
export * from "./AccionAlerta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports